import { Component, Input, OnInit } from '@angular/core';
import { CheckboxControl } from '../../../models/controls/checkbox-control';
import { TranslationsService } from '../../../services/translations/translations.service';
import { NgForm } from '@angular/forms';
import { PasswordControl } from '../../../models/controls/password-control';
import { LoginInformation } from '../../../models/intefaces/login-information';

const MinimumPasswordLength = 6;

@Component({
  selector: 'app-account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.scss'],
})
export class AccountInformationComponent implements OnInit {
  @Input()
  form?: NgForm;

  logged = false;

  readonly control = new CheckboxControl('create-new-account', 'accountLink');
  readonly password = new PasswordControl('password', 'Password');
  readonly confirmPassword = new PasswordControl(
    'confirm_password',
    'ConfirmPassword'
  );

  constructor(private readonly translationsService: TranslationsService) {}

  ngOnInit(): void {
    this.logged = this.translationsService.getTranslations().authenticated;
    this.password.min = MinimumPasswordLength;
    this.confirmPassword.min = MinimumPasswordLength;
  }

  isFormVisible(): boolean {
    return !this.logged || !this.control.value;
  }

  export(): LoginInformation {
    return {
      confirmPassword: this.confirmPassword.value as string,
      password: this.password.value as string,
    };
  }
}
